import { createReducer, on } from '@ngrx/store';
import {
  sharedResourcesStoreCurrent,
  sharedResourcesStoreRemoveFromCurrent,
  sharedResourcesUpdateCurrent,
} from '@core/shared-resources/store/shared-resources.actions';
import { SharedResources } from '@core/shared-resources/shared-resources.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface SharedResourcesState extends EntityState<SharedResources> {
  currentResource: SharedResources;
}
export const sharedResourcesAdapter: EntityAdapter<SharedResources> =
  createEntityAdapter<SharedResources>({
    selectId: (resource: SharedResources) => resource.resourceType + '_' + resource.resourceId,
  });

export const sharedResourcesInitialState: SharedResourcesState =
  sharedResourcesAdapter.getInitialState({
    currentResource: {
      resourceId: undefined,
      resourceType: undefined,
      teamMembers: [],
    },
  });

export const sharedResourcesReducer = createReducer(
  sharedResourcesInitialState,
  on(sharedResourcesStoreCurrent, (state, { resourceId, resourceType, teamMembers }) => ({
    ...state,
    currentResource: {
      resourceId: +resourceId,
      resourceType,
      teamMembers: teamMembers ? teamMembers : [],
    },
  })),
  on(sharedResourcesUpdateCurrent, (state, { resourceId, resourceType, teamMembers }) => ({
    ...state,
    currentResource: {
      resourceId: resourceId ? +resourceId : state.currentResource.resourceId,
      resourceType: resourceType ? resourceType : state.currentResource.resourceType,
      teamMembers: teamMembers ? teamMembers : state.currentResource.teamMembers,
    },
  })),
  on(sharedResourcesStoreRemoveFromCurrent, (state, { memberId }) => ({
    ...state,
    currentResource: {
      resourceId: state.currentResource.resourceId,
      resourceType: state.currentResource.resourceType,
      teamMembers: state.currentResource.teamMembers?.filter((item) => item.id !== memberId),
    },
  })),
);
